
import { apiService } from '../../service/api.service'

export default {
  props: {
    show: { type: Boolean, default: false }
  },
  computed: {
    dialogOpen: {
      get () { return this.show || this.dialogRegister },
      set (v) {
        this.dialogRegister = v
        if (!v) this.$emit('close')
      }
    }
  },
  data () {
    return {
      dialogRegister: false,
      valid: true,
      error401: false,
      errorDef: false,
      errorMsg: '',
      loading: false,
      show1: false,
      newUser: { name: null, email: null, password: null, passwordConfirm: null },
      rules: {
        required: (value) => !!value || 'Required.',
        equal: value => value === this.newUser.password || 'Passwords do not match.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid email address.'
        },
        password: (value) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*?'/()=.:;])(?=.{8,})/
          return pattern.test(value) || 'Min. 8 chars with uppercase, lowercase, number and special character.'
        }
      }
    }
  },
  methods: {
    async handleSubmit (): Promise<void> {
      const form = this.$refs.form as HTMLFormElement
      if (form.validate()) {
        this.loading = true
        this.errorDef = false
        this.errorMsg = ''
        apiService.post('admin-create-user', this.newUser)
          .then(() => { this.close(); this.$emit('call-users') })
          .catch((error) => {
            this.errorMsg = error.response?.data?.message || ''
            this.errorDef = true
          })
          .finally(() => { this.loading = false })
      }
    },
    close (): void {
      this.dialogRegister = false
      this.$emit('close')
      this.$refs.form.reset()
    }
  },
  watch: {
    dialogOpen (n: boolean): void {
      if (n && this.$refs.form) (this as any).$refs.form.resetValidation()
    }
  }
}
